export enum CattlesSortOrderings {
	BY_GROUP = 'group__title',
	BY_LACTATION = '-lactation_length',
	BY_LAST_MILK_AMOUNT = 'last_milking_amount',
	BY_LAST_MILKING_DT = 'last_milking_dt',
	BY_FATNESS = 'fatness',
	BY_LIMPNESS = 'limpness',
}
